import * as React from 'react';
export function useInitToastStacksApiByPlacement() {
  var bottomCenterStackApi = React.useState([]);
  var bottomRightStackApi = React.useState([]);
  var topCenterStackApi = React.useState([]);
  var topRightStackApi = React.useState([]);
  return React.useMemo(function () {
    return {
      'bottom-center': bottomCenterStackApi,
      'bottom-right': bottomRightStackApi,
      'top-center': topCenterStackApi,
      'top-right': topRightStackApi
    };
  }, [bottomCenterStackApi, bottomRightStackApi, topCenterStackApi, topRightStackApi]);
}